import { h, Component } from 'preact';
import MiniMap from './MiniMap';
import MiniScale from './MiniScale';

class UnemploymentRateMapGrid extends Component {
  constructor() {
    super();
  }

  componentDidMount() {}

  render() {
    let snapshots = ['February 2020', 'April 2020', 'July 2020', 'May 2021'];

    return (
      <div class="mini-map-grid-container">
        <div class="mini-scale-container">
          <MiniScale />
        </div>
        <div class="mini-map-grid">
          {snapshots.map(date => {
            return (
              <div class="mini-map-block">
                <div class="mini-map-header-container">
                  <h4 class="mini-map-header">{date}</h4>
                </div>
                <MiniMap date={date} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default UnemploymentRateMapGrid;
